'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.resetStubbedThread = undefined;

var _reduxActions = require('redux-actions');

var _StubbedThreadHistoryActionTypes = require('../constants/StubbedThreadHistoryActionTypes');

var resetStubbedThread = exports.resetStubbedThread = (0, _reduxActions.createAction)(_StubbedThreadHistoryActionTypes.RESET_STUBBED_THREAD);